<template>
  <div class="together">
      <searchTogether></searchTogether>
       <div class="title-group">
            <p class="title">揪團列表</p>
                <div class="sort-type">排序方式 
                <span @click="toggleSortType('date')" :class="{'active':searchForm.sortType == 'date'}">最新</span>|
                <span @click="toggleSortType('hot')" :class="{'active':searchForm.sortType == 'hot'}">熱門</span>
            </div>
        </div>
      
      <togetherItem :itemList = "allItems" @success="success"></togetherItem>
      <div  class="no-data" v-if="allItems.length < 1">暫無開團</div>
      <el-pagination
        v-if="allItems.length > 0"
            background
            layout="prev, pager, next"
            :page-size="12"
            :total="pageSetting.totalPages"
            :current-page.sync ="pageSetting.curPage"
            @current-change="getExchangeItemList()"
            >
        </el-pagination>
  </div>
</template>

<script>
import { getTogetherItemList  } from '../../api/together'; 
import searchTogether from './components/searchTogether'
import togetherItem from './components/togetherItem'

export default {
    components:{
        searchTogether,
        togetherItem,
    },
    data(){
        return {
            showAddTogether: false,
            showTogetherDetail: false,
            searchForm:{
                sortType:'date',
                creator:'',
                category:"",
                ownMember: "",
                targetMember: ""
            },
            allItems: [],
            pageSetting:{
                totalPages: null,
                curPage: 1,
            }
        }
    },
    mounted(){
        this.getTogetherItemList()
    },
    methods:{
        toggleSortType(type){
             this.searchForm.sortType = type
             this.pageSetting.curPage = 1
             this.getTogetherItemList()
        },
        getTogetherItemList(){
            let params = this.searchForm
            params.curPage = this.pageSetting.curPage
            getTogetherItemList(params).then(res => {
                this.allItems = res.body
                this.pageSetting.totalPages = res.totalCount
            })
        },
        openAddTogether(){
            this.showAddTogether = true
        },
        openTogetherDetail(){
            this.showTogetherDetail = true
        },
        success(){
            this.getTogetherItemList()
        }
    }
}
</script>

<style lang="scss" scoped>
.together {
     .title-group {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 50px auto 0;
        max-width: 1200px;
        box-sizing: border-box;
        padding: 0 27px;
    }
    .title {
        font-size: 30px;
    }
    .sort-type{
        span {
            margin: 0 10px;
            color: $textColor;
            cursor: pointer;
            &:hover,&.active {
                color:$mainColor;
            }
        }
    }
    .no-data {
        text-align: center;
        color:$textColor;
        padding: 100px 0;
        font-size: 20px;
    }
    .el-pagination {
        text-align: center;
    }

}
</style>